import { useStyletron } from '@thanx/uikit/theme'
import React from 'react'
import { Container } from 'react-bootstrap-five'
import CodeTypes from './CodeTypes'
import Comparison from './Comparison'
import FooterCta from './FooterCta'
import Hero from './Hero'
import WherePromoCodesWork from './WherePromoCodesWork'

type Props = {
  onCreateClick: () => void
  onGoToOloConfig: () => void
}

const Overview = ({ onCreateClick, onGoToOloConfig }: Props) => {
  const [css] = useStyletron()

  return (
    <Container className="pt-l">
      <div
        className={css({
          display: 'flex',
          flexDirection: 'column',
          gap: '48px',
        })}
      >
        <Hero onCreateClick={onCreateClick} />
        <Comparison />
        <WherePromoCodesWork onActivateOlo={onGoToOloConfig} />
        <CodeTypes />
        <FooterCta onCreateClick={onCreateClick} />
      </div>
    </Container>
  )
}

export default Overview
